var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L10.1047 10.1047M10.1047 10.1047C10.5999 9.60942 10.9928 9.02147 11.2608 8.37438C11.5289 7.72729 11.6668 7.03375 11.6668 6.33335C11.6668 5.63295 11.5289 4.9394 11.2608 4.29232C10.9928 3.64523 10.5999 3.05727 10.1047 2.56202C9.60942 2.06676 9.02147 1.6739 8.37438 1.40586C7.72729 1.13783 7.03375 0.999878 6.33335 0.999878C5.63295 0.999878 4.9394 1.13783 4.29232 1.40586C3.64523 1.6739 3.05727 2.06676 2.56202 2.56202C1.5618 3.56224 0.999878 4.91882 0.999878 6.33335C0.999878 7.74787 1.5618 9.10446 2.56202 10.1047C3.56224 11.1049 4.91882 11.6668 6.33335 11.6668C7.74787 11.6668 9.10446 11.1049 10.1047 10.1047Z",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.7dec0aee04c4f851bf63461806ab8574.svg";
export { ForwardRef as ReactComponent };